import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { TabListProps } from "../../../../Common/UI/Tabs/Tabs";
import { DialogNavTabsView } from "./DialogNavTabs.view";
import { Menus, Navigation } from "./Types";

/**
 * Logic for nav tab in dialog box
 * @returns Nav bar in dialog box
 */
export const DialogNavTabs: React.FC = () => {
  const dispatch = useDispatch();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const selectedTab = outputConfig.selectedTab;

  /**
   * Function to get the current tabsList for output config dialog
   * @returns list of tabs items
   */
  const getTabsList = (): TabListProps[] => {
    const tabsList: TabListProps[] = [];
    const outputDetailMenusList = Object.values(Menus);
    outputDetailMenusList.forEach((detailTabName: string) => {
      const customKey = detailTabName.replace(/\s+/g, "-").toLowerCase();
      tabsList.push({
        value: customKey,
        label: detailTabName
      });
    });
    return tabsList;
  };

  /**
   * Function that returns the currently selected menu to emis ui package
   * @param menu - selected tab menu
   * @returns - key of the selected tab
   */
  const getSelectedMenu = (menu: string): string => {
    const tabsList: TabListProps[] = getTabsList();

    const menuPropToKey = menu.replace(/\s+/g, "-").toLowerCase();
    const activeMenuTab = tabsList.find((tabsMenu: TabListProps) => tabsMenu.value === menuPropToKey);

    if (activeMenuTab && activeMenuTab.value === menuPropToKey) {
      return activeMenuTab.value;
    }

    return "";
  };


  /**
   * Handler for the menu selection
   * @param currentMenu active menu of the output config
   */
  const onMenuSelect = (currentMenu: string): void => {
    const menus = {
      "details": Navigation.DETAILS,
      "banding": Navigation.BANDING,
      "config": Navigation.OUTPUT_CONFIG,
      "final-output": Navigation.FINAL_OUTPUT
    };

    dispatch(OutputConfigSlice.actions.selectTab(menus[currentMenu]));
  };

  useEffect(() => {
    // Setting width if the indicator width is 0
    const tabIndicator = document.querySelectorAll(".Tabs_tabIndicator_eRJAO3lx")[1] as HTMLElement;
    if (tabIndicator?.style?.width === "0px") {
      tabIndicator.style.width = "89px";
    }
    // To reset the active tab while unmounting
    return ((): void => {
      dispatch(OutputConfigSlice.actions.selectTab(Navigation.DETAILS));
    });
  }, []);

  return (
    <DialogNavTabsView
      tabsList = {getTabsList()}
      onMenuSelect={onMenuSelect}
      menu={getSelectedMenu(selectedTab)}
    />
  );
};
